import * as Rules from '../Rules'
import { setValidity } from '../Utils/classOperations'

export function errorBagCreator (rulesRaw) {
  let errorBag = []

  // {rule: 'required', ruleParams: '', valid: false, feedback: 'error message'}
  rulesRaw.forEach(function (r) {
    if (r.includes(':')) {
      let rSplit = r.split(':')
      errorBag.push({
        rule: rSplit[0],
        ruleParams: rSplit[1],
        valid: false,
        feedback: ''
      })
    } else {
      errorBag.push({
        rule: r,
        ruleParams: '',
        valid: false,
        feedback: ''
      })
    }
  })

  return errorBag
}

export function ruleRunner (vObj, options) {
  let errorBag = vObj.errorBag

  errorBag.forEach(function (eb) {
    eb.valid = Rules[eb.rule].validate(vObj)
  })
  vObj.valid = !errorBag.some(e => e.valid === false)

  setValidity(vObj, options)
}

/*
required      --> no :
isPostcode    --> no :
isPhoneNumber --> no :

required_if : otherField,value,value,value --> arr[2]
min : 1                                    --> arr[2]
max : 50                                   --> arr[2]

*/
